import './App.css';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/Navbar';
import Contact from './components/Contact';
import ImageCard from './components/ImageCard';
import WhyChoose from './components/WhyChoose';
import Gallery from './components/Gallery';
import Act from './components/Acts';
import { EstimateIcon, StatIcon } from './components/Icons';
import imageRepOne from './assets/amar.png';
import imageRepTwo from './assets/clopay.jpeg';
import imageRepThree from './assets/chi.png';
import imageRepFour from './assets/carriage.jpeg';
import imageRepSix from './assets/liftmaster.png';
import garageHeroSmall from './assets/garage-hero-1280.jpg';
import garageHeroLarge from './assets/garage-hero-1920.jpg';
import { scrollToEstimate } from './utils/navigation';

const stats = [
  { icon: 'experience', value: '20+', label: 'Years of Experience', detail: 'Two decades of trusted service and expertise.' },
  { icon: 'doors', value: '10,000+', label: 'Garage Doors Installed', detail: 'Successfully installed for homes across California.' },
  { icon: 'guarantee', value: '100%', label: 'Satisfaction Guarantee', detail: 'We stand behind our work and your satisfaction.' },
  { icon: 'reviews', value: '5-Star', label: 'Customer Rated', detail: 'Hundreds of five-star reviews from happy customers.' },
];

const services = [
  {
    title: 'Free Estimates',
    icon: 'estimate',
    description: 'Get a fast, free, no-obligation estimate tailored to your home. We’ll inspect your current door and opener, explain your options, and provide a clear quote with no hidden fees.',
  },
  {
    title: 'Installation',
    icon: 'installation',
    description: 'Choose from durable doors in classic carriage-house, contemporary, and custom styles. Our specialists make sure every installation looks beautiful and performs reliably.',
  },
  {
    title: 'Repair & Maintenance',
    icon: 'repair',
    description: 'From broken springs and damaged panels to noisy or malfunctioning openers, we diagnose the issue and deliver the right repair to keep your system running safely.',
  },
];

const manufacturers = [
  {
    brand: 'Amarr',
    imageRep: imageRepOne,
    url: 'https://www.amarr.com/us/en',
    desc: 'American-made residential and commercial doors known for thoughtful design, dependable construction, and sustainable manufacturing.',
  },
  {
    brand: 'Clopay',
    imageRep: imageRepTwo,
    url: 'https://www.clopaydoor.com/',
    desc: 'A wide selection of materials, finishes, insulation options, and profiles that can completely transform your home’s curb appeal.',
  },
  {
    brand: 'C.H.I.',
    imageRep: imageRepThree,
    url: 'https://www.chiohd.com/',
    desc: 'Decades of experience crafting high-quality garage doors, backed by exceptional warranties and a broad range of distinctive styles.',
  },
  {
    brand: 'Carriage House Door',
    imageRep: imageRepFour,
    url: 'https://www.carriagedoor.com/',
    desc: 'Custom garage doors, gates, and shutters created with exacting attention to detail, personalized design support, and premium materials.',
  },
  {
    brand: 'LiftMaster',
    imageRep: imageRepSix,
    url: 'https://www.liftmaster.com/',
    desc: 'Quiet, connected garage door openers with advanced smart-home and security features designed to simplify and protect everyday life.',
  },
];

function App() {
  return (
    <div id="top" className="Container">
      <Analytics />
      <Navbar />

      <header className="Home-Image">
        <picture className="Hero-Media">
          <source media="(max-width: 900px)" srcSet={garageHeroSmall} />
          <img src={garageHeroLarge} alt="" fetchpriority="high" />
        </picture>
        <div className="Home-Overlay" />
        <div className="Introduction">
          <div className="Introduction-Content">
            <div className="Headline">
              <h1 className="Introduction-Title">Golden State<br />Garage Doors</h1>
            </div>
            <p className="Introduction-Subtitle">California’s Premier Garage Door Experts</p>
            <button className="Introduction-Button" type="button" onClick={scrollToEstimate}>
              <EstimateIcon /> <span>Get Free Estimate</span>
            </button>
          </div>
        </div>
      </header>

      <section className="Trust-Section" aria-label="Why homeowners trust Golden State Garage Doors">
        <div className="Introduction-Stats">
          {stats.map((stat) => (
            <article className="Introduction-Stat" key={stat.label}>
              <div className="Stat-Icon"><StatIcon type={stat.icon} /></div>
              <strong className="Stat-Value">{stat.value}</strong>
              <p>{stat.label}</p>
              <span className="Stat-Line" />
              <small>{stat.detail}</small>
            </article>
          ))}
        </div>
      </section>

      <main>
        <section className="Services-Section">
          <div id="Services-Start" className="Section-Heading">
            <p className="Section-Eyebrow">WHAT WE DO</p>
            <h2 id="ServiceTitles" className="Services">Garage Door Services</h2>
            <p className="Service-Desc">From a quick repair to a complete upgrade, we make taking care of your garage door simple.</p>
          </div>
          <div className="ServiceTitles">
            {services.map((service) => <Act key={service.title} {...service} />)}
          </div>
        </section>

        <WhyChoose />

        <Gallery />

        <section id="CardSet" className="CardSet">
          <div className="Section-Heading">
            <p className="Section-Eyebrow">TRUSTED MANUFACTURERS</p>
            <h2 className="Services">Doors &amp; Openers We Recommend</h2>
            <p className="Service-Desc">Quality products from brands we trust to perform beautifully for years.</p>
          </div>
          <div className="CardsBackground">
            <div className="Cards">
              {manufacturers.map((manufacturer) => <ImageCard key={manufacturer.brand} {...manufacturer} />)}
            </div>
          </div>
        </section>

        <div className="ContactBackground">
          <Contact />
          <footer className="Site-Footer">
            <div className="Footer-Line" />
            <p className="Footer-Copyright">© {new Date().getFullYear()} Golden State Garage Doors. All rights reserved.</p>
          </footer>
        </div>
      </main>
    </div>
  );
}

export default App;
